export type HomeSectionTheme = "light" | "dark";

export const HOME_SECTION_THEME_STYLES = {
  light: {
    section: "bg-gray-50 text-gray-900",
    heading: "text-gray-900",
    body: "text-gray-600",
    card: "nokodia-card-surface border-gray-200 bg-white",
    cardHeading: "text-gray-900",
    cardBody: "text-gray-600",
  },
  dark: {
    section: "bg-black text-white",
    heading: "text-white",
    body: "text-gray-300",
    card: "nokodia-card-surface border-white/10 bg-white/[0.045]",
    cardHeading: "text-white",
    cardBody: "text-gray-300",
  },
} as const;
